import { useSelect as useCoupons } from '@/pages/activity/coupon/api';
import { Select, SelectProps } from '@arco-design/web-react';
import React from 'react';

export const SelectCoupon = ({
  value,
  onChange,
  placeholder = '全部',
  ...rest
}: SelectProps & {
  useName?: boolean;
  addThird?: boolean;
}) => {
  const { data, isLoading } = useCoupons({
    params: {
      pageSize: 100,
      pageIndex: 1,
    },
  });

  const options = data
    ? data.data.items.map((v) => ({
        label: v.name,
        value: v.id,
      }))
    : [];
  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      loading={isLoading}
      {...rest}
      options={options}
      allowClear
    />
  );
};
